( function( global, $ ) {
    "use strict";

    window.HtmlUtil = window.HtmlUtil || {};

    window.HtmlUtil.getDom = function (html) {
        var result = html.replace(/<body/, '<div ajax-response-body')
            .replace('</body>', '</div>')
            .replace('<head', '<div ajax-response-head')
            .replace('</head>', '</div>');

        return $('<div />').html(result);
    };

    window.HtmlUtil.getBody = function (html) {
        return window.HtmlUtil.getDom(html).find('> div[ajax-response-body]');
    };

    window.HtmlUtil.getHead = function (html) {
        return window.HtmlUtil.getDom(html).find('> div[ajax-response-head]');
    };

    window.onAjaxLink = function(ev) {
        ev.preventDefault();

        var app = $('body').data('App'),
            $link = $(this),
            $container = $(app.main),
            $initiator = $link.is('[data-ajax-link]') ? $link : $link.closest('[data-ajax-links]'),
            url = $link.attr('href'),
            urlSelector = url + ' ' + $container.attr('id') + ' > *',
            scrollTo = $initiator.data('scroll-to');

        showLoading();
        $container.load(urlSelector, null, function(responseText, textStatus, req) {
            window.history.replaceState({provider: 'ajax-link'}, '', url);

            if (textStatus === 'error') {
                window.location.reload();
            }

            // Check for real redirect response
            var $responseBody = window.HtmlUtil.getBody(responseText);

            if ($responseBody.data('app') &&
                $responseBody.data('app').url &&
                $responseBody.data('app').url !== window.location.href
            ) {
                window.history.replaceState({provider: 'ajax-link'}, '', url);
            }

            $container.app();

            if (typeof(scrollTo) !== 'undefined') {
                if (scrollTo === 'auto') {
                    scrollTo = $container.offset().top;
                } else if ('number' !== typeof(scrollTo)) {
                    scrollTo = $container.find(scrollTo).offset().top;
                }

                $(window).scrollTop(scrollTo);
            }
        });
    };

    function showLoading() {
        $('body').data('App').showLoading();
    }

    function hideLoading() {
        $('body').data('App').hideLoading();
    }

    window.onAjaxSubmit = function(ev) {
        ev.preventDefault();

        var $form = $(this);

        if (! $form.get(0).checkValidity()) {
            $form.attr('data-form-invalid', '');
            return;
        }

        if ($form.data('form-state')) {
            return;
        }

        $form.data('form-state', 'ajax-submit');

        // Lock keyboard
        $(document).bind('keydown.ajax-submit', function(ev) {
            ev.preventDefault();
            return false;
        });

        setTimeout(function() {
            $form.ajaxSubmit();
            showLoading();

            var xhr = $form.data('jqxhr'),
                app = $('body').data('App'),
                activeElementId = $(document.activeElement).attr('id'),
                scrollTo = $form.data('scroll-to');

            xhr.done(function (html, textStatus, jqXhr) {
                var $container = $(app.main),
                    $responseBody = window.HtmlUtil.getBody(html),
                    $responseContainer = $responseBody.find('#' + app.options.mainId);

                if (false !== $form.data('ajax-history') &&
                    $responseBody.data('app') &&
                    $responseBody.data('app').url &&
                    $responseBody.data('app').url !== window.location.href
                ) {
                    window.history.replaceState({provider: 'ajax-submit'}, '', $responseBody.data('app').url);
                }

                $container.html($responseContainer.html());
                $container.app();

                var $activeElement = $container.find('#' + activeElementId).focus();

                if ($activeElement.length) {
                    $activeElement.focus();

                    if ($activeElement.prop('tagName') === 'INPUT'
                            && ['text', 'number', 'search'].indexOf($activeElement.attr('type')) !== -1) {
                        // Set cursor at the end
                        $activeElement.val($activeElement.val());
                    }
                }

                if (typeof(scrollTo) !== 'undefined') {
                    if (scrollTo === 'auto') {
                        scrollTo = $container.offset().top;
                    }

                    $(window).scrollTop(scrollTo);
                }
            });

            xhr.fail(function() {
                hideLoading();
                $form.data('form-state', null);
            });

            xhr.always(function() {
                $(document).unbind('keydown.ajax-submit');
            });
        }, 10);
    };

    var _events = {
        onInputLink: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                href = $this.data('input-href') ? $this.data('input-href') : $this.val();

            if ($this.is('[data-ajax-link]')) {
                return $('<a />').attr('href', href).attr('data-ajax-link', true).hide()
                    .appendTo('body').trigger('click');
            }

            window.location.assign(href);
        }
    };

    var $body = $('body');

    $body.on('app.ready', function(ev) {
        $body.on('click', 'a[data-ajax-link], [data-ajax-links] a', window.onAjaxLink);
        $body.on('change', '[data-input-link]', _events.onInputLink);
    });

    window.location.ajax = function(url) {
        return $('<a />').attr('href', url).attr('data-ajax-link', true).hide()
            .appendTo('body').trigger('click');
    };

    window.location.ajaxReload = function() {
        return window.location.ajax(window.location.href);
    };

}( window.groots, jQuery ));
